// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"232":"login-view","372":"home-view"}[chunkId] + "." + {"232":"3efa9c8b","372":"2294af68"}[chunkId] + ".chunk.css";
};